import React from 'react'
import type { TeamStatsModule } from './teamStats'

interface ModuleCardProps {
  module: TeamStatsModule
  icon: React.ReactNode
}

// Module performance card from the mockup: lime accent border, three stats, progress bar
const ModuleCard: React.FC<ModuleCardProps> = ({ module, icon }) => {
  return (
    <div className="rounded-[10px] p-3.5" style={{ background: 'var(--m2-card)', border: '1px solid var(--m2-line)', borderLeft: '3px solid var(--m2-lime)' }}>
      <div className="flex items-start justify-between mb-2.5">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-md flex items-center justify-center shrink-0" style={{ background: 'var(--m2-mint)', color: 'var(--m2-ink)' }}>
            {icon}
          </div>
          <div>
            <div className="text-[13px] font-bold leading-tight" style={{ color: 'var(--m2-ink)' }}>
              {module.moduleName}
            </div>
            <div className="text-[10px] mt-px" style={{ color: 'var(--m2-muted)' }}>
              {module.rolePlayCount} role-plays &middot; {module.enrolledCount} reps enrolled
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2.5 mb-2">
        <div>
          <div className="text-[9.5px] mb-0.5" style={{ color: 'var(--m2-muted)' }}>
            Completion
          </div>
          <div className="text-[13px] font-bold" style={{ color: 'var(--m2-ink)' }}>
            {Math.round(module.completionPct)}%
          </div>
        </div>
        <div>
          <div className="text-[9.5px] mb-0.5" style={{ color: 'var(--m2-muted)' }}>
            Avg score
          </div>
          <div className="text-[13px] font-bold" style={{ color: 'var(--m2-ink)' }}>
            {module.avgScore.toFixed(1)}{' '}
            <span className="text-[10px] font-normal" style={{ color: 'var(--m2-amber)' }}>
              &#9733;
            </span>
          </div>
        </div>
        <div>
          <div className="text-[9.5px] mb-0.5" style={{ color: 'var(--m2-muted)' }}>
            Mastered
          </div>
          <div className="text-[13px] font-bold" style={{ color: 'var(--m2-ink)' }}>
            {module.masteredCount}{' '}
            <span className="text-[10px] font-medium" style={{ color: 'var(--m2-muted)' }}>
              / {module.masteredTotal}
            </span>
          </div>
        </div>
      </div>
      <div className="h-[5px] rounded-[3px] overflow-hidden" style={{ background: 'var(--m2-line-soft)' }}>
        <div className="h-full" style={{ background: 'var(--m2-lime)', width: `${Math.min(100, Math.round(module.completionPct))}%` }} />
      </div>
    </div>
  )
}

export default ModuleCard
